<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
export default {
	props: {
		xunzfjxx: {
			type: Boolean,
			default: false
		},
		srk: {
			//附加内容
			type: Array,
			default: function() {
				return [];
			}
		}
	},
	watch: {
		xunzfjxx: function(indexVal, oldVal) {
			if (indexVal) {
				this.selectfjxx();

			}
		},
		srk: function(indexVal, oldVal) {
			if (indexVal) {

			}
		},
	},
	data() {
		return {
			headData: getdata().headData,
			tableData: [],
			fujxxmc: '',
			tempName: '',
			options: getdata().options,
			newfj: false,
			datatype: ''
		};
	},
	created() {},
	mounted() {

	},

	methods: {
		choz() {
			this.fujxxmc = '';
			this.selectfjxx()
		},
		newfjtk() {
			this.tempName = '';
			this.datatype = '';
			this.newfj = true;
		},
		Addfjxx() {
			if (!this.tempName) {
				this.$message.error('异常提示:附加信息名称不能为空');
				return;
			}
			if (!this.datatype) {
				this.$message.error('异常提示: 数据类型不能为空');
				return;
			}
			let patea = {
				fujxxmc: this.tempName,
				shujlx: this.datatype
			};
			this.$https.fetchPost('felec/addInformMaintain/addAddInformItem', patea).then(res => {
				if (res.data.code == '200') {
					this.$message.success('成功');
					this.newfj = false;
					this.selectfjxx();
				} else {
					this.$message.error('失败');
				}
			});
		},
		returnrke() {
			if (this.$refs.tablebox.getSelectionval().length == 0) {
				this.$message.error('请选择数据');
				return;
			}
			this.$emit('returnrke', this.$refs.tablebox.getSelectionval());
			this.closexunzfjxx();
		},
		closexunzfjxx() {
			this.$emit('closexunzfjxx', false);
		},
		selectfjxx() {
			let patea = {
				limit: 10000000,
				page: 1,
				param: {
					likeContent:this.fujxxmc
				}
			};
			this.$https.fetchPost('felec/addInformMaintain/getAddInformItemList', patea).then(res => {
				if (res.data.code == '200') {
					res.data.data.sort(function(a, b) {
						return a.xuh - b.xuh;
					});
					this.tableData = res.data.data;
					// this.$nextTick(function () {
					// 	this.$refs.tablebox.toggleSelection(this.srk)
					// })				
				} else {
					this.$message.error('失败');
				}
			});
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
